import { MessageTemplateType } from '@factoryfixinc/ats-interfaces';
import type { MessageTemplate } from './template.type';

export const TEMPLATE_CHIPS = [
  '[Company Name]',
  '[Pro FullName]',
  '[Pro FirstName]',
  '[My Name]',
  '[Job Title]',
];

/**
 * Explicit values for a personalized template preview. Every surface without a selected
 * conversation must pass these, otherwise TemplateService.mapTemplatePlaceholders falls
 * back to the conversation index and can render an unrelated candidate's name.
 */
export interface TemplatePreviewContext {
  proFullName?: string;
  /** Pass alongside `proFullName` so the preview greets the pro exactly as the send will. */
  proFirstName?: string;
  jobTitle?: string;
}

/**
 * A template the current user owns, i.e. one they may edit or delete. The templates
 * endpoint returns the global FactoryFix set alongside the caller's own and the DTO
 * carries no owner id, so `type` is the only signal available.
 */
export function isCustomTemplate(template: Pick<MessageTemplate, 'type'>): boolean {
  return template.type !== MessageTemplateType.FACTORYFIX;
}

/** How a template preview renders its placeholders. */
export type TemplatePreviewMode = 'raw' | 'personalized';

/** Which subview of the template library is showing. */
export type TemplateLibraryMode = 'browse' | 'create' | 'edit';
